import { api } from '../axios'
import type { ApiResponse } from '../types'

export type AgingScope = 'ALL' | 'DIRECTORATE' | 'SECRETARIAT'
export type AgingBucket = 'GREEN' | 'YELLOW' | 'RED'

export interface AgingApplicationRow {
  id: number
  status: string
  admin_scope: string | null
  appliedAt: string
  currentStepId: number | null
  current_role: string | null
  current_step_name: string | null
  days_pending: number
  aging_bucket: AgingBucket
}

export interface AgingSummary {
  scope: AgingScope
  totals: { totalOpen: number; green: number; yellow: number; red: number }
  bottlenecks: {
    topN: number
    hoi: Array<{ school_id: string; school_name: string; avg_days: number; count: number }>
    sdeo: Array<{ rd_block: string; avg_days: number; count: number }>
    deo: Array<{ district: string; avg_days: number; count: number }>
    directorate_roles: Array<{ role: string; avg_days: number; count: number }>
    secretariat_roles: Array<{ role: string; avg_days: number; count: number }>
  }
}

export const agingAnalyticsApi = {
  getSummary: (params?: { scope?: AgingScope; topN?: number }) =>
    api.get<ApiResponse<AgingSummary>>('/aging-analytics/summary', { params }),

  getApplications: (params?: { scope?: AgingScope; page?: number; limit?: number; status?: string; minDays?: number; bucket?: AgingBucket | string }) =>
    api.get<ApiResponse<AgingApplicationRow[]> & { pagination?: any }>('/aging-analytics/applications', { params }),

  exportApplicationsExcel: (params?: { scope?: AgingScope; status?: string; minDays?: number; bucket?: AgingBucket | string }) =>
    api.get<Blob>('/aging-analytics/applications/export/excel', { params, responseType: 'blob' }),
}

